import { Box } from '@material-ui/core';
import { SEmptyState, SText } from '@setvi/shared/components';

interface ErrorProps {
  value: string;
}
export const Error = ({
  value = 'Not Enough Information to Compare Products'
}: ErrorProps) => (
  <Box height="100%" display="flex" justifyContent="center" alignItems="center">
    <SEmptyState
      width={226}
      height={160}
      additionalContent={
        <SText
          noLineClamp
          weight="semibold"
          title={value}
          style={{
            marginTop: 24
          }}
        />
      }
      imageSrc="/images/empty/no-data-found.png"
      imageAlt="Not enough data"
    />
  </Box>
);
